"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSettingsValue = void 0;
var generateKey_1 = require("../../generateKey");
var translationDefaultFunction_1 = require("./translationDefaultFunction");
function getSettingsValue(values, param, options) {
    var _a, _b;
    if (options === void 0) { options = {}; }
    var generatedKey = generateKey_1.generateKey(param.key, { isMobile: options.isMobile });
    if (typeof values[generatedKey] !== 'undefined') {
        return values[generatedKey];
    }
    if (generatedKey !== param.key && typeof values[param.key] !== 'undefined') {
        return values[param.key];
    }
    return param.getDefaultValue({
        t: (_a = options.t) !== null && _a !== void 0 ? _a : translationDefaultFunction_1.getTranslationDefaultFunction({
            environmentLabel: (_b = options.environmentLabel) !== null && _b !== void 0 ? _b : '`getSettingsValue` function',
        }),
    });
}
exports.getSettingsValue = getSettingsValue;
//# sourceMappingURL=getSettingsValue.js.map